import React from 'react';
import { useNavigate } from 'react-router-dom';
import HeroSection from '../hero';
import HomeInfo from '../homeinfo';
import SubFooter from '../sub-footer';
import Testimonial from '../testimonial';
import ProductGrid from '../productgrid';
import productsData from '../data/products.json';

const Home = () => {
  const navigate = useNavigate();

  // Shuffle products for home page
  const shuffledProducts = [...productsData.products].sort(() => Math.random() - 0.5);

  // Handler for View More button
  const handleViewMore = () => {
    navigate('/products');
  };

  return (
    <>
      <HeroSection />
      <HomeInfo />
      <ProductGrid 
        products={shuffledProducts}
        layout="grid-4"
        maxItems={8}
        sectionTitle="Our Products"
        showViewMore={true}
        onViewMore={handleViewMore}
      />
      {/* <Testimonial /> */}
      <SubFooter />
    </>
  );
};

export default Home;